var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHintFailure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 88",
    enableBackground: "new 0 0 88 88",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF6375",
    d: "M44,88.0002441c-24.2617188,0-44-19.7382812-44-44.0004883c0-24.2617188,19.7382812-44,44-44 s44,19.7382793,44,44C88,68.2619629,68.2617188,88.0002441,44,88.0002441z M44,7.9997568c-19.8505878,0-36,16.1494141-36,36 c0,19.8510704,16.1494122,36.0004807,36,36.0004807s36-16.1494102,36-36.0004807C80,24.1491699,63.8505859,7.9997568,44,7.9997568z "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6375",
    d: "M58.0208092,62.0206261c-1.0234337,0-2.0478516-0.3906212-2.8281212-1.1718712L27.1506958,32.8077393 c-1.5620136-1.5624981-1.5620136-4.0947266,0-5.6572266c1.5625-1.5615215,4.0947266-1.5615215,5.6572266,0L60.848938,55.1925049 c1.5625,1.5615234,1.5625,4.0947227,0,5.65625C60.0686646,61.6300049,59.0442505,62.0206261,58.0208092,62.0206261z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6375",
    d: "M29.9793072,62.0206261c-1.0239277,0-2.0473614-0.3906212-2.8286114-1.1718712 c-1.5620136-1.5615273-1.5620136-4.0947266,0-5.65625L55.192688,27.1505127c1.5605431-1.5615215,4.0956993-1.5615215,5.65625,0 c1.5625,1.5625,1.5625,4.0947285,0,5.6572266L32.8079224,60.8487549 C32.0266724,61.6300049,31.003233,62.0206261,29.9793072,62.0206261z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHintFailure);
export default __webpack_public_path__ + "static/media/icon_hint_failure.13e51e116fdd956b7e1070628113c01a.svg";
export { ForwardRef as ReactComponent };